import {
  NoshowAlertFilters,
  NoshowAlertsResponse,
  NoshowAlertDetailResponse,
  NoshowStatsResponse,
} from '../types/noshowAlerts';
import { axiosRubyClient as api } from '@/util/axios/axiosClient';

export const noshowAlertsAPI = {
  getAlerts: async (
    filters: NoshowAlertFilters,
  ): Promise<NoshowAlertsResponse> => {
    const response = await api.get('/api/admin/noshow_alerts', {
      params: filters,
    });
    return response.data;
  },

  getAlert: async (id: number): Promise<NoshowAlertDetailResponse> => {
    const response = await api.get(`/api/admin/noshow_alerts/${id}`);
    return response.data;
  },

  getStats: async (
    dateFrom?: string,
    dateTo?: string,
  ): Promise<NoshowStatsResponse> => {
    const response = await api.get('/api/admin/noshow_alerts/stats', {
      params: { date_from: dateFrom, date_to: dateTo },
    });
    return response.data;
  },

  resolveAlert: async (
    id: number,
    notes: string,
  ): Promise<{ success: boolean; message: string }> => {
    const response = await api.post(`/api/admin/noshow_alerts/${id}/resolve`, {
      notes,
    });
    return response.data;
  },

  updateAlert: async (
    id: number,
    data: { backfill_job_id?: number; notes?: string; status?: string },
  ): Promise<{ success: boolean; message: string }> => {
    const response = await api.patch(`/api/admin/noshow_alerts/${id}`, data);
    return response.data;
  },
};
